import type { AncestorNode, ChildNode } from './models';
import {
    type AddMarkOperation,
    type AnyOperation,
    Block,
    BlockRange,
    Change,
    type ChangeFlags,
    Data,
    Document,
    Fragment,
    type FragmentMap,
    History,
    Inline,
    type InsertArrayDataOperation,
    type InsertFragmentOperation,
    type InsertNodeOperation,
    type InsertTextOperation,
    isParentPathEqual,
    isPathEqual,
    Leaf,
    Mark,
    type MarkOperation,
    type MarkProperties,
    type MergeNodeOperation,
    type MoveNodeOperation,
    type NodeOperation,
    Operation,
    type OperationSide,
    type RemoveArrayDataOperation,
    type RemoveDataOperation,
    type RemoveFragmentOperation,
    type RemoveMarkOperation,
    type RemoveNodeOperation,
    type RemoveTextOperation,
    Schema,
    type SchemaNormalizeContextForViolation,
    type SchemaNormalizeFn,
    type SchemaNormalizeViolationFn,
    type SchemaRule,
    type SelectionRange,
    type SetDataOperation,
    type SetDocumentOperation,
    type SetFragmentOperation,
    type SetNodeOperation,
    type SetSelectionOperation,
    type SplitNodeOperation,
    Text,
    type TextOperation,
    TextRange,
    type ValidateNodeFn,
    Value,
} from './models';
import {
    generateKey,
    isBlockRangeSelection,
    isTextRangeSelection,
    resetKeyGenerator,
    setKeyGenerator,
    setSequentialKeyGenerator,
} from './utils';

export * from './constants/schema-violations';
export * from './models/node-serialization';
export * from './protobuf';

/**
 * Utility type to allow importing SlateDocument directly in contexts where multiple Document types may exist.
 */
type SlateDocument = Document;

export {
    type SlateDocument,
    type AnyOperation,
    type AddMarkOperation,
    Block,
    BlockRange,
    Change,
    type ChangeFlags,
    Data,
    Document,
    History,
    Fragment,
    type FragmentMap,
    Inline,
    type InsertArrayDataOperation,
    type InsertFragmentOperation,
    type InsertTextOperation,
    type InsertNodeOperation,
    Leaf,
    type MergeNodeOperation,
    Mark,
    type MarkOperation,
    type MarkProperties,
    type MoveNodeOperation,
    type NodeOperation,
    Operation,
    type OperationSide,
    type RemoveArrayDataOperation,
    type RemoveDataOperation,
    type RemoveFragmentOperation,
    type RemoveMarkOperation,
    type RemoveNodeOperation,
    type RemoveTextOperation,
    type SelectionRange,
    type SetDataOperation,
    type SetFragmentOperation,
    type SetNodeOperation,
    type SetDocumentOperation,
    type SetSelectionOperation,
    Schema,
    type SchemaRule,
    type SchemaNormalizeContextForViolation,
    type SchemaNormalizeFn,
    type SchemaNormalizeViolationFn,
    type SplitNodeOperation,
    type ValidateNodeFn,
    Text,
    TextRange,
    type TextOperation,
    Value,
    isBlockRangeSelection,
    isTextRangeSelection,
    generateKey,
    resetKeyGenerator,
    setKeyGenerator,
    setSequentialKeyGenerator,
    type ChildNode,
    type AncestorNode,
    isParentPathEqual,
    isPathEqual,
};
